import { Separator, Text } from "../../common";
import { useSubscriptionPlan } from "../../../hooks";
import React from "react";
import { E_MultiplayerServiceName } from "@repo-sapiens/data-access-models";
import { MultiplayerServices } from "../../../utils/constants";
import { ServiceItem } from "./components";

type Props = {
  onSelected: (service: E_MultiplayerServiceName, value: boolean) => void;
  selectedServices: E_MultiplayerServiceName[];
};
export const MultiplayerServicesLayout: React.FC<Props> = ({
  onSelected,
  selectedServices,
}) => {
  const { isFree } = useSubscriptionPlan();
  //const [services, setServices] = React.useState<
  //  {
  //    id: ServiceName;
  //    title: string;
  //    subtitle: string;
  //    Icons: React.FC<SVGProps>[];
  //    selected: boolean;
  //    scopes: string[];
  //  }[]
  //>(MultiplayerServices);
  //// force re-render when selectedServices changes
  //React.useEffect(() => {
  //  setServices((prev) =>
  //    prev.map((service) => ({
  //      ...service,
  //      selected: selectedServices.includes(service.id),
  //    })),
  //  );
  //}, [selectedServices]);

  return (
    <>
      <Text.H4 color="seconday">
        How would you like your Assistant to work for you?
      </Text.H4>

      <Separator.Horizontal spacing={5} />

      {MultiplayerServices.map((service) => (
        <ServiceItem
          key={service.id}
          title={service.title}
          subtitle={service.subtitle}
          Icons={service.Icons}
          selected={isFree ? false : selectedServices.includes(service.id)}
          onSelected={(value) => onSelected(service.id, value)}
          disabled={
            (isFree && service.id !== E_MultiplayerServiceName.InboxManagement) ||
            service.disabled
          }
          disabledMessage="Upgrade your account to unlock this feature"
        />
      ))}
    </>
  );
};
export * from "./components";
